import { Box, styled } from '@mui/material';

/** 저장 HTML 의 회사명 줄·거래처 표·안내 문구(레거시 #eas_bp_content) */
export const AccountingBpRoot = styled(Box)`
  & .form-group + .form-group,
  & .form-group + .approval-form-table-scroll {
    margin-top: 12px;
  }
  & #sap_company_text,
  & .form-group > span {
    font-weight: 600;
  }
  & .approval-form-table th {
    word-break: keep-all;
  }
  & .account-change-notice {
    margin: 8px 0 0;
    font-size: 14px;
    line-height: 20px;
    color: var(--dk-danger, #f55060);
  }
  & .selected-partner-info {
    margin-top: 16px;
  }
`;

export const AccountingBpLinkButton = styled('button')`
  display: inline-flex;
  padding: 4px;
  border: 0;
  background: none;
  color: var(--dk-text-strong, #4d5157);
  cursor: pointer;

  &:hover {
    color: var(--dk-accent, #0066cc);
  }
`;
